import React from 'react';
import { MARQUEE_ITEMS } from '../data/homeData';

function MarqueeSet({ idPrefix = 'a', hidden = false }) {
  return (
    <div className="marquee-set" aria-hidden={hidden}>
      {MARQUEE_ITEMS.map((text, i) => (
        <span key={`${idPrefix}-${i}`} className="marquee-chip">
          {text}
        </span>
      ))}
    </div>
  );
}

function Marquee() {
  return (
    <div className="marquee-bar" aria-label="Export services highlights">
      <div className="marquee-track">
        <MarqueeSet idPrefix="a" />
        <MarqueeSet idPrefix="b" hidden />
      </div>
    </div>
  );
}

export default Marquee;
